<div class="menu-icons js-toggle-menu-icons">
	<div
		class="menu-icons__button menu-icons__button--main"
		[ngClass]="[main.color ? main.color : '', isOpen ? 'active' : '' ]"
		[ngStyle]="getIconStyle()" (click)="toggle()">
		<i class="menu-icons__button__i" [ngClass]="main.icon"></i>
	</div>
	@if (isOpen) {
		<div
			class="menu-icons__list"
			[ngStyle]="setListPosition()">
			@for (item of items; track item) {
				<div
					class="menu-icons__list__item">
					<div
						class="menu-icons__list__item__label"
						[ngClass]="item.color">
						<div class="menu-icons__list__item__label__text">{{item.label}}</div>
					</div>
					<div
						class="menu-icons__button menu-icons__button--list"
						[ngClass]="item.color"
						(click)="onItemClick(item.onClick)"
						[ngStyle]="getIconStyle()">
						<i class="menu-icons__button__i" [ngClass]="item.icon"></i>
					</div>
				</div>
			}
		</div>
	}
</div>
